export const SDK_VERSION = "2.19.0";
